import React from 'react';

import PropTypes from 'prop-types';

import { HolidaysProvider } from '../../context';

/**
 * Wrapper that wraps the Holiday route components with the Context Provider
 * @param {Object} props - Component props
 * @param {React.Component} props.component - Route component to wrap
 * @param {Object} props.routeProps - Route props
 */
const HolidayWrapper = ({ component: Component, routeProps = {}, ...rest }) => {
  return (
    <HolidaysProvider>
      <Component {...routeProps} {...rest} />
    </HolidaysProvider>
  );
};

HolidayWrapper.propTypes = {
  component: PropTypes.elementType.isRequired,
  routeProps: PropTypes.object,
};

export default HolidayWrapper;
